<template lang="pug">
  b-container
    transition(name="fade")
      .selected-products-floating-widget.bg-primary.text-center.text-white.p-3(v-if="selectedProds.length")
        p Seleccionados {{ selectedProds.length }}
        .d-flex.justify-content-center.align-items-center
          .circle-button.mr-3(@click="categoriesModal=true;")
            span(style="font-size:11px;") CAT
          .circle-button.mr-3(@click="confirmDeleteProducts")
            trash-2-icon.icon-md
          .circle-button(@click="selectedProds = [];allSelected = false;")
            x-icon.icon-md
    b-form-group
      b-input-group
        b-form-input(placeholder="Buscar producto..." v-model="searchProduct")
        template(#append)
          b-input-group-text
            search-icon.icon-md
    .my-3
      b-form-checkbox(@change="selectAll" v-model="allSelected") Seleccionar todos
    b-card(no-body)
      b-table.card-table.mb-0(:items="parsed_products", :fields="fields", responsive, @row-clicked="$emit('select-product', $event)", hover, show-empty, :busy="loading")
        template(v-slot:empty)
          p.mb-0.text-secondary No hay productos disponibles
        template(v-slot:table-busy)
          .text-center
            b-spinner(variant="primary")
        template(v-slot:cell(name)="{ item }")
          .d-flex.align-items-start
            b-form-checkbox(@change="productChecked(item, $event)" :checked="selectedProds.map(p => p.product_id).includes(item.product_id)" size="lg")
            b-img.mr-2(:src="item.image", v-if="item.image && !item.error", @error="item.error = true", width="40", height="40", rounded="circle")
            div
              b-link.text-dark(@click="$emit('select-product', item)") {{ item.name }}
              .text-sm.text-warning(v-if="kanguro_enabled && item.missing_measures")
                alert-circle-icon.icon-sm.mb-1
                span.ml-1 Medidas no especificadas
              p.mb-0.text-secondary.text-sm {{ item.description }}
              div.text-sm.mt-2
                b-badge.mr-1(variant="light", v-for="category in item.Categories", :key="category.category_id") {{ category.name }}
              b-dropdown.mt-2(dropright, variant="light", size="sm", no-caret, boundary="window")
                template(slot="button-content")
                  span Compartir
                  external-link-icon.icon-sm.ml-1
                //b-dropdown-header Konverza shop
                //b-dropdown-form
                  .d-flex.align-items-center
                    b-link.mr-2.text-reset(style="flex:1", v-b-tooltip.hover="'Ir a página'", :href="'https://' + account.username + '.konverza.me/?ref=' + reference + item.product_id", target="_blank") {{account.username + '.konverza.me'}}
                    copy-icon.icon-md.pointer.hover-primary(v-b-tooltip.hover="'Copiar enlace'", @click="copy(`https://${account.username}.konverza.me/?ref=${reference}${item.product_id}`)")
                b-dropdown-header(v-if="messenger_accounts.length") Messenger
                b-dropdown-form(v-for="m_account in messenger_accounts", :key="m_account.external_id")
                  .d-flex.align-items-center
                    b-link.mr-2.text-reset(style="flex:1", v-b-tooltip.hover="'Ir a página'", :href="'https://m.me/' + m_account.external_id + '?ref=' + reference + item.product_id", target="_blank") {{m_account.name}}
                    copy-icon.icon-md.pointer.hover-primary(v-b-tooltip.hover="'Copiar enlace'", @click="copy(`https://m.me/${m_account.external_id}?ref=${reference}${item.product_id}`)")
                //b-dropdown-item(v-for="m_account in messenger_accounts", :key="m_account.external_id", :href="'https://m.me/' + m_account.external_id + '?ref=' + reference + item.product_id", target="_blank") {{m_account.name}}
        template(v-slot:cell(price)="{ item }")
          p.mb-0 {{ item.price }}
        template(v-slot:cell(enabled)="{ item }")
          b-form-checkbox.mr-2(switch, v-model="item.enabled", @change="updateProduct(item, $event)")
        //template(v-slot:cell(actions)="{ item }")
          edit-3-icon.icon-md.mr-4.hover-primary.pointer(v-b-tooltip.hover="'Editar'", @click.stop="openProductModal(item)")
          trash-2-icon.icon-md.hover-danger.pointer(v-b-tooltip.hover="'Eliminar'", @click.stop="confirmDeleteProduct(item)")
    .d-flex.align-items-center
      b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getProducts')", v-if="v_paginationShow")
      b-spinner.ml-3(small, variant="primary", v-if="loading")

    b-modal(v-model="categoriesModal", ok-only, ok-variant="primary" ok-title="Cerrar" title="Editar categorías")
      b-container
        b-card.no-shadow(v-for="(category, index) in categories" :key="index")
          b-row
            b-col
              h5.mb-0 {{ category.name }}
            b-col(cols="auto")
              .d-flex.align-items-center
                .circle-button.mr-3.bg-danger(@click="removeCategory(category.category_id)")
                  x-icon.text-white
                .circle-button.bg-success(@click="assignCategory(category.category_id)")
                  check-icon.text-white

            b-col(cols="12" v-if="category.Children && category.Children.length")
              hr

            b-col.pl-4.subcat-rows(cols="12" v-for="(subcategory, sindex) in category.Children" :key="sindex")
              b-row
                b-col
                  p.mb-0 {{ subcategory.name }}
                b-col(cols="auto")
                  .d-flex.align-items-center
                    .circle-button.mr-3.small.bg-danger(@click="removeCategory(subcategory.category_id)")
                      x-icon.text-white.icon-sm
                    .circle-button.small.bg-success(@click="assignCategory(subcategory.category_id)")
                      check-icon.text-white.icon-sm
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from 'lodash.debounce'
import treeselectOptions from '@/data/treeselect-options'
import ProductVariantValues from '@/components/ProductVariants'

const accountController = createNamespacedHelpers('account')
const productController = createNamespacedHelpers('product')
const ecommerceController = createNamespacedHelpers('delivery')
const categoryController = createNamespacedHelpers('category')

export default {
  data () {
    return {
      treeselect_options: treeselectOptions,
      fields: [
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'price',
          label: 'Precio'
        },
        {
          key: 'stock',
          label: 'Stock'
        },
        {
          key: 'enabled',
          label: 'Estado'
        }
      ],
      loading: false,
      messenger_accounts: [],
      searchProduct: '',
      searchTimeout: null,
      selectedProds: [],
      allSelected: false,
      categoriesModal: false
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account
    }),
    ...productController.mapState({
      products: state => state.products,
      all_products: state => state.all_products
    }),
    ...ecommerceController.mapState({
      ecommerce_data: state => state.ecommerce_data
    }),
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    kanguro_enabled () {
      return this.ecommerce_data.delivery_type_id == 2
    },
    parsed_products () {
      const measures = ['weight', 'width', 'height', 'length']
      const formatter = new Intl.NumberFormat(
        'es-MX',
        { style: 'currency', currency: 'MXN' }
      )

      return this.products.map(p => {
        let missingMeasures = false

        for (let key in p) {
          if (measures.includes(key) && (!p[key] || p[key] === '' || p[key] <= 0)) {
            missingMeasures = true

            break
          }
        }

        p.price = String(p.price).replace('$', '')
        p.price = formatter.format(p.price || 0)

        p.missing_measures = missingMeasures

        return p
      })
    },
    reference () {
      switch (this.account.type) {
        case 'konverza-ecommerce':
          return 'MostrarProducto:'
          break
        case 'konverza-leads-gallery':
          return 'Solicitar:'
          break
        default :
          return 'MostrarProducto:'
          break
      }
    },
  },
  methods: {
    ...mapActions([
      'platform/get',
      'product/all',
      'delivery/ecommerce',
      'product/update',
      'product_variant/all',
      'product_variant/create',
      'product_variant/update',
      'product_variant/destroy',
      'product_variant/assign_value',
      'product_variant/update_value',
      'product_variant/remove_value',
      'product/destroy',
      'product/assignCategory',
      'product/removeCategory',
      'category/all'
    ]),
    getProduct (product_id) {
      let self = this

      this['product/get']({
        account_id: self.$route.params.account_id,
        product_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let index = self.products.findIndex(p => p.product_id == product_id)
            if (index >= 0) {
              self.products.splice(index, 1, res.resource)
            }
          }
        }
      })
    },
    getProducts () {
      let self = this
      this.loading = true

      this['product/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
          category: self.$route.params.category_id != 'all' ? self.$route.params.category_id : null,
          name: self.searchProduct || null
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
            self.scrollToTop()
          }
        }
      })
    },
    getEcommerceData () {
      let self = this

      this['delivery/ecommerce']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    scrollToTop () {
      this.$scrollTo('#product-container', 500, {
        container: '#product-container',
        offset: -20
      })
    },
    async updateProduct (product, value) {
      if (this.selectedProds.length) {
        this.updateAll('enabled', value != undefined ? value : product.enabled)
        return
      }
      const self = this

      product.enabled = value != undefined ? value : product.enabled

      this['product/update']({
        account_id: self.$route.params.account_id,
        ...product,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Producto actualizado')
        }
      })
    },
    async updateProductPromise (product, param, value) {
      product[param] = value
      return new Promise ((resolve) => {
        this['product/update']({
          account_id: this.$route.params.account_id,
          ...product,
          callback: res => {
            resolve()
          }
        })
      })
    },
    async deleteProductPromise (product) {
      return new Promise ((resolve) => {
        this['product/destroy']({
          account_id: this.$route.params.account_id,
          ...product,
          callback: res => {
            resolve()
          }
        })
      })
    },
    copy (url) {
      let dummy = document.createElement("textarea")
      document.body.appendChild(dummy)
      dummy.value = url
      dummy.select()
      document.execCommand("copy")
      document.body.removeChild(dummy)
    },
    productChecked (prod, value) {
      if (value == true) {
        this.selectedProds.push(prod)
      } else {
        const index = this.selectedProds.findIndex(p => p.product_id == prod.product_id)
        console.log(index);
        if (index >= 0) {
          this.selectedProds.splice(index, 1)
        }
      }
    },
    updateAll (param, value) {
      let promises = []

      for (let product of this.selectedProds) {
        promises.push(this.updateProductPromise(product, param, value))
      }

      Promise.all(promises).then(res => {
        this.$message.success('Productos actualizados')
      })
    },
    deleteAll () {
      let promises = []
      for (let prod of this.selectedProds) {
        promises.push(this.deleteProductPromise(prod))
      }

      Promise.all(promises).then(res => {
        this.$message.success('Productos eliminados')
        this.selectedProds = []
        this.allSelected = false
      })
    },
    confirmDeleteProducts() {
      let self = this;

      this.$bvModal
        .msgBoxConfirm(
          `¿Deseas eliminar los productos seleccionados? No se puede deshacer.`,
          {
            title: "Eliminar productos",
            okTitle: "Eliminar",
            okVariant: "danger",
            cancelTitle: "Cancelar",
          }
        )
        .then((value) => {
          if (value == true) {
            self.deleteAll()
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    assignCategory (category_id) {
      let promises = []
      for (let prod of this.selectedProds) {
        promises.push(this.assignCategoryPromise(category_id, prod.product_id))
      }

      Promise.all(promises).then(res => {
        this.$message.success('Categoría asignada')
      })
    },
    assignCategoryPromise(category_id, product_id) {
      return new Promise(resolve => {
        this["product/assignCategory"]({
          product_id: product_id,
          category_id: category_id,
          callback: (res) => {
            resolve()
          },
        });
      })
    },
    removeCategory (category_id) {
      let promises = []
      for (let prod of this.selectedProds) {
        promises.push(this.removeCategoryPromise(category_id, prod.product_id))
      }

      Promise.all(promises).then(res => {
        this.$message.success('Categoría quitada')
      })
    },
    removeCategoryPromise(category_id, product_id) {
      return new Promise(resolve => {
        this["product/removeCategory"]({
          product_id: product_id,
          category_id: category_id,
          callback: (res) => {
            resolve()
          },
        });
      })
    },
    selectAll (value) {
      console.log(value);
      if (value == true) {
        this.selectedProds = this.products.map(p => p)
        this.allSelected = true
      }
      else {
        this.selectedProds = []
        this.allSelected = false
      }
    },
    getCategories() {
      let self = this;
      this.loading = true;

      this["category/all"]({
        account_id: self.$route.params.account_id,
        params: {
          relationship : "parent",
        },
        callback: (res) => {
          self.loading = false;
          if (res.error) {
            self.$message.error(res.error);
          }
        },
      });
    },
  },
  mounted () {
    let self = this
    this['platform/get']({
      account_id: self.$route.params.account_id,
      platform_id: 'messenger',
      callback: res => {
        if (res.error) {
          self.$message.error(res.error)
        } else {
          self.messenger_accounts = res.resource
        }
      }
    })

    this.setPaginationLimit(50)
    this.getEcommerceData()
    this.getProducts()
    this.getCategories()
  },
  watch: {
    '$route' (value) {
      this.resetPaginationData()
      this.getProducts()
    },
    all_products (val, old_val) {
      if(val.length && !old_val.length)
        this.getProducts()
    },
    searchProduct (value) {
      clearTimeout(this.searchTimeout)
      if (!value.trim().length) {
          this.resetPaginationData()
          this.getProducts()
      } else {
        this.searchTimeout = setTimeout(() => {
          this.resetPaginationData()
          this.getProducts()
        }, 700);
      }
    },
    categoriesModal (value) {
      if (value === false) {
        this.getProducts()
      }
    }
  },
  components: { ProductVariantValues }
}
</script>

<style lang="scss" scoped>
  .selected-products-floating-widget {
    position: fixed;
    width: 300px;
    height: 100px;
    left: calc(50% - 150px);
    top: 1rem;
    border-radius: 5px;
    z-index: 100;
  }

  .circle-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    background-color: #2d40e7;
    cursor: pointer;

    &:hover {
      background-color: #2335d3;
    }

    &.small {
      width: 25px;
      height: 25px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(-30px);
    opacity: 0;
  }

  .subcat-rows {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
</style>
